import React from 'react';
import HeaderMenuItem from './HeaderMenuItem';
import HeaderMenuAboutUs from './HeaderMenuAboutUs';

const HeaderMenuDropdown = ({items, depth, parentId, isMobile, isServicesMenu}) => {
    if (!items || items.length === 0) {
        return null;
    }

    let classes = isServicesMenu ? "submenu-wrapper services-wrapper" : 'submenu-wrapper';

    const content = (
        <ul className={`submenu depth-${depth}`} data-parent={parentId}>
            {items.map((item) => (
                <HeaderMenuItem key={item.id} item={item} depth={depth} isMobile={isMobile}/>
            ))}
        </ul>
    );

    if (isMobile) {
        return content; 
    }

    return depth === 1 && isServicesMenu  ? (
        <div className={classes}>
            {content}
            {isServicesMenu && <HeaderMenuAboutUs/>}
        </div>
    ) : (
        content
    );
};

export default HeaderMenuDropdown;
